import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FullCycleDiscountView from './FullCycleDiscountView';
import { formatAmount } from '@/presentation/modules/payments/modules/PayOnline/helpers';
import { Creators as requestBenefitInfoActions } from '@/domain/useCases/payments/getBenefitInstallmentsInfo';

interface DiscountData {
  amountWithBenefit?: number | string;
  totalDiscount?: number | string;
  totalAmount?: number | string;
  totalInstallments?: number | string;
  startDate?: number;
  endDate?: number;
}

const FullCycleDiscountViewController = () => {
  const dispatch = useDispatch();
  const { goBack } = useHistory();
  const [dataDiscount, setDataDiscount] = useState<any>(null);

  const { data: dataBInfo, isLoading } = useSelector(
    (state: any) => state.getBenefitInstallmentsInfo
  );

  const handlerBack = () => {
    goBack();
  };

  const handleFormatAmount = (total?: string) => {
    if (!total) return null;
    return formatAmount(total) ?? null;
  };

  const handleMapDataDiscount = (data?: DiscountData) => {
    if (!data) {
      setDataDiscount(null);
      return;
    }
    const dataMap = {
      ...data,
      amountWithBenefit:
        handleFormatAmount(data.amountWithBenefit?.toString()) ?? '-',
      totalDiscount: handleFormatAmount(data.totalDiscount?.toString()) ?? '-',
      totalAmount: handleFormatAmount(data.totalAmount?.toString()) ?? '-',
      totalInstallments: data.totalInstallments ?? '-',
      startDate: data.startDate ?? Date.now(),
      endDate: data.endDate ?? Date.now()
    };
    setDataDiscount(dataMap);
  };

  useEffect(() => {
    dispatch(requestBenefitInfoActions.getBenefitInstallmentsInfo());
    document.title = `UTP + Portal | Descuento ciclo completo`;
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);

  useEffect(() => {
    handleMapDataDiscount(dataBInfo);
  }, [dataBInfo, isLoading]);

  return (
    <FullCycleDiscountView
      dataDiscount={dataDiscount}
      isLoading={isLoading}
      handlerBack={handlerBack}
    />
  );
};

export default FullCycleDiscountViewController;
